import { action } from 'typesafe-actions';

import { EnterpriseId } from 'types/models/enterprise';

import ActionTypes from './constants';

// ================================================
// Download Devices and Sample Points CSV
// ================================================
export const downloadDevicesAndSamplePointsCSV = (
  enterpriseId: EnterpriseId,
  enterpriseName: string,
  apiConnected?: boolean
) =>
  action(ActionTypes.LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_REQUEST, {
    enterpriseId,
    enterpriseName,
    apiConnected
  });

export const downloadDevicesAndSamplePointsCSVSuccess = () =>
  action(ActionTypes.LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_SUCCESS);

export const downloadDevicesAndSamplePointsCSVFailure = () =>
  action(ActionTypes.LOAD_CSV_DEVICES_WITH_SAMPLEPOINTS_LIST_FAILURE);
